<template>
  <div class="data-table-filter">
    <BaseFilterBar
      v-if="showFilterBar"
      :search-placeholder="searchPlaceholder"
      :search="search"
      :filters="filters"
      :values="filterValues"
      @filter-change="handleFilterChange"
      @submit="handleSubmit"
    />
    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :group-by="groupBy"
      :group-subtotals="groupSubtotals"
      :server-items-length="serverItemsLength"
      :options="options"
      @detail="$emit('row-detail', $event)"
      @update:options="handleOptionsChange"
    />
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import BaseFilterBar from './BaseFilterBar.vue'

const FILTER_BAR_THRESHOLD = 10

export default {
  name: 'BaseDataTableFilter',
  components: { BaseDashboardTable, BaseFilterBar },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    forceFilterBar: {
      type: Boolean,
      required: false,
      default: false
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    groupBy: {
      type: String,
      required: false,
      default: ''
    },
    groupSubtotals: {
      type: Object,
      required: false,
      default: () => ({})
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    filterValues: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    showFilterBar() {
      return this.forceFilterBar || this.rows.length > FILTER_BAR_THRESHOLD
    }
  },
  methods: {
    handleFilterChange(key, value) {
      const filter = this.filters.find((candidate) => candidate.key === key)
      if (!filter || !filter.param) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn(`BaseDataTableFilter: filtro "${key}" sem "param" na spec — alteração ignorada.`)
        }
        return
      }
      this.$emit('filter-change', { instance: this.instance, param: filter.param, value })
    },
    handleOptionsChange(newOptions) {
      this.$emit('update:options', { instance: this.instance, options: newOptions })
    },
    handleSubmit(value) {
      this.$emit('submit', { instance: this.instance, value })
    }
  }
}
</script>
